import React from 'react';
import './AnimatedLogo.css';

const AnimatedLogo = ({ size = 'medium', className = '' }) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'logo-small';
      case 'large': return 'logo-large';
      default: return 'logo-medium';
    }
  };

  return (
    <div className={`animated-logo ${getSizeClass()} ${className}`}>
      <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* 背景圆形 */}
        <circle cx="60" cy="60" r="60" fill="#2A9FD6"/>
        
        {/* 外层海浪包裹 - 更大更全面 */}
        <path 
          d="M15 25 Q15 10 30 10 Q50 10 65 20 Q80 30 80 45 Q80 60 65 70 Q50 80 30 80 Q15 80 15 65 Q15 50 25 50 Q35 50 50 55 Q50 65 35 65 Q25 65 20 55 Q20 45 30 45 Q40 45 55 55 Q55 65 40 65 Q30 65 25 55 Q25 45 15 45 Z" 
          fill="white"
          className="wave-container"
        />
        
        {/* 内层海浪装饰 - 更大 */}
        <path 
          d="M20 30 Q25 25 30 30 Q35 35 30 40 Q25 45 20 40 Q15 35 20 30" 
          stroke="white" 
          strokeWidth="2.5" 
          fill="none" 
          opacity="0.8"
          className="wave-decoration"
        />
        <path 
          d="M25 35 Q30 30 35 35 Q40 40 35 45 Q30 50 25 45 Q20 40 25 35" 
          stroke="white" 
          strokeWidth="2" 
          fill="none" 
          opacity="0.6"
          className="wave-decoration"
        />
        <path 
          d="M30 40 Q35 35 40 40 Q45 45 40 50 Q35 55 30 50 Q25 45 30 40" 
          stroke="white" 
          strokeWidth="1.5" 
          fill="none" 
          opacity="0.4"
          className="wave-decoration"
        />
        
        {/* 中心比特币符号 - 更大更清晰 */}
        <path 
          d="M42 20 L58 20 L58 30 L52 30 L52 35 L58 35 L58 45 L52 45 L52 50 L58 50 L58 60 L52 60 L52 65 L58 65 L58 75 L52 75 L52 80 L58 80 L58 90 L42 90 L42 80 L36 80 L36 75 L42 75 L42 65 L36 65 L36 60 L42 60 L42 50 L36 50 L36 45 L42 45 L42 35 L36 35 L36 30 L42 30 Z" 
          fill="#2A9FD6"
          className="bitcoin-symbol"
        />
        <path 
          d="M44 32 L46 32 L46 38 L44 38 Z" 
          fill="white"
        />
        <path 
          d="M44 52 L46 52 L46 58 L44 58 Z" 
          fill="white"
        />
        <path 
          d="M44 72 L46 72 L46 78 L44 78 Z" 
          fill="white"
        />
        
        {/* 底部波浪装饰 - 更大 */}
        <path 
          d="M30 80 Q35 75 40 80 Q45 85 50 80 Q55 75 60 80 Q65 85 70 80 Q75 75 80 80 Q85 85 90 80" 
          stroke="white" 
          strokeWidth="2.5" 
          fill="none" 
          opacity="0.7"
          className="bottom-wave"
        />
        <path 
          d="M32 85 Q37 80 42 85 Q47 90 52 85 Q57 80 62 85 Q67 90 72 85 Q77 80 82 85 Q87 90 92 85" 
          stroke="white" 
          strokeWidth="2" 
          fill="none" 
          opacity="0.5"
          className="bottom-wave"
        />
        <path 
          d="M34 90 Q39 85 44 90 Q49 95 54 90 Q59 85 64 90 Q69 95 74 90 Q79 85 84 90 Q89 95 94 90" 
          stroke="white" 
          strokeWidth="1.5" 
          fill="none" 
          opacity="0.3"
          className="bottom-wave"
        />
      </svg>
    </div>
  );
};

export default AnimatedLogo; 